export enum DataIssueType {
  UnreliableCountry,
  ServicesInGeneral,
}
